// FilterBar: filter and sort controls for tours list
import React from "react";

export default function FilterBar({ filters, onChange }) {
  const handleChange = (e) => {
    const { name, value } = e.target;
    onChange({ ...filters, [name]: value });
  };

  return (
    <div className="grid grid-cols-2 gap-3 rounded-lg border border-slate-200 bg-white p-4 dark:border-slate-800 dark:bg-slate-900 md:grid-cols-6">
      <input
        name="q"
        value={filters.q || ""}
        onChange={handleChange}
        placeholder="Search tours"
        className="col-span-2 rounded-md border border-slate-300 px-3 py-2 text-sm dark:border-slate-700 dark:bg-slate-800 dark:text-slate-100"
      />
      <input
        name="city"
        value={filters.city || ""}
        onChange={handleChange}
        placeholder="City"
        className="rounded-md border border-slate-300 px-3 py-2 text-sm dark:border-slate-700 dark:bg-slate-800 dark:text-slate-100"
      />
      <input
        type="number"
        name="minPrice"
        value={filters.minPrice || ""}
        onChange={handleChange}
        onFocus={(e) => e.target.select()}
        placeholder="Min Price"
        className="rounded-md border border-slate-300 px-3 py-2 text-sm dark:border-slate-700 dark:bg-slate-800 dark:text-slate-100"
      />
      <input
        type="number"
        name="maxPrice"
        value={filters.maxPrice || ""}
        onChange={handleChange}
        onFocus={(e) => e.target.select()}
        placeholder="Max Price"
        className="rounded-md border border-slate-300 px-3 py-2 text-sm dark:border-slate-700 dark:bg-slate-800 dark:text-slate-100"
      />
      <select
        name="sortBy"
        value={filters.sortBy || ""}
        onChange={handleChange}
        className="rounded-md border border-slate-300 px-3 py-2 text-sm dark:border-slate-700 dark:bg-slate-800 dark:text-slate-100"
      >
        <option value="">Sort</option>
        <option value="price_asc">increasing price</option>
        <option value="price_desc">Decreasing price</option>
        <option value="rating_desc">Best Mark</option>
      </select>
      <button
        onClick={() =>
          onChange({ q: "", city: "", minPrice: "", maxPrice: "", sortBy: "" })
        }
        className="rounded-md bg-slate-900 px-3 py-2 text-sm text-white hover:bg-slate-700 dark:bg-slate-100 dark:text-slate-900 dark:hover:bg-white"
      >
        Réinitialiser
      </button>
    </div>
  );
}
